import React, { ReactElement } from 'react';

import { Container } from './VisuallyHidden.styled';

interface VisuallyHiddenProps {
  children: React.ReactNode;
}

export function VisuallyHidden({
  children,
  ...props
}: VisuallyHiddenProps): ReactElement {
  return <Container {...props}>{children}</Container>;
}
